import { styled } from '@mui/material/styles';
import { Chip as MuiChip } from '@mui/material';


const Chip = styled(MuiChip)(({ theme }) => ({
    color: theme.palette.primary.contrastText,
}));

export default Chip;